import {Component} from 'react'

class Profile extends Component {
  render() {
    return (
      <>
        <h1>Profile</h1>
      </>
    )
  }
}

export default Profile
